import { motion } from "framer-motion";

export function DestinationHero({ destination, description, heroImage }) {
  return (
    <section style={{ paddingTop: "80px", paddingBottom: "32px" }}>
      <div style={{ margin: "0 12px" }}>

        {/* Hero card */}
        <div style={{
          position: "relative",
          width: "100%",
          height: "calc(100vh - 112px)",
          minHeight: "560px",
          borderRadius: "20px",
          overflow: "hidden",
        }}>
          {/* Background image — slow zoom in */}
          <motion.div
            initial={{ scale: 1.07 }}
            animate={{ scale: 1 }}
            transition={{ duration: 2, ease: [0.25, 0.46, 0.45, 0.94] }}
            style={{
              position: "absolute",
              inset: 0,
              backgroundImage: `url(${heroImage})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
            }}
          />

          {/* Gradient: bottom-to-top for text legibility */}
          <div style={{
            position: "absolute",
            inset: 0,
            background: "linear-gradient(to top, rgba(0,0,0,0.90) 0%, rgba(0,0,0,0.35) 45%, rgba(0,0,0,0.08) 100%)",
          }} />

          {/* Gradient: left sweep for extra legibility */}
          <div style={{
            position: "absolute",
            inset: 0,
            background: "linear-gradient(to right, rgba(0,0,0,0.55) 0%, rgba(0,0,0,0) 55%)",
          }} />

          {/* Content block — pinned bottom-left */}
          <div style={{
            position: "absolute",
            bottom: 0,
            left: 0,
            right: 0,
            padding: "0 48px 52px",
          }}>
            <div style={{ maxWidth: "520px" }}>

              <motion.span
                initial={{ opacity: 0, y: 12 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.55, delay: 0.3, ease: "easeOut" }}
                style={{
                  display: "inline-block",
                  color: "#E8470A",
                  fontSize: "11px",
                  fontWeight: 700,
                  letterSpacing: "0.28em",
                  textTransform: "uppercase",
                  marginBottom: "14px",
                }}
              >
                Destino Alohar
              </motion.span>

              <motion.h1
                initial={{ opacity: 0, y: 22 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.7, delay: 0.45, ease: "easeOut" }}
                style={{
                  fontSize: "clamp(40px, 6vw, 72px)",
                  fontWeight: 800,
                  color: "#ffffff",
                  lineHeight: 0.95,
                  margin: "0 0 16px",
                }}
              >
                {destination}
              </motion.h1>

              <motion.p
                initial={{ opacity: 0, y: 16 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.65, delay: 0.63, ease: "easeOut" }}
                style={{
                  color: "rgba(255,255,255,0.75)",
                  fontSize: "15px",
                  lineHeight: 1.65,
                  margin: "0 0 28px",
                }}
              >
                {description}
              </motion.p>

              <motion.div
                initial={{ opacity: 0, y: 12 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: 0.82, ease: "easeOut" }}
                style={{ display: "flex", flexWrap: "wrap", gap: "12px" }}
              >
                <a
                  href="#alojamientos"
                  style={{
                    display: "inline-flex",
                    alignItems: "center",
                    backgroundColor: "#E8470A",
                    color: "#ffffff",
                    fontWeight: 700,
                    fontSize: "14px",
                    padding: "12px 24px",
                    borderRadius: "999px",
                    textDecoration: "none",
                    boxShadow: "0 4px 16px rgba(232,71,10,0.4)",
                  }}
                >
                  Ver alojamientos
                </a>
                <a
                  href="#destino"
                  style={{
                    display: "inline-flex",
                    alignItems: "center",
                    backgroundColor: "rgba(255,255,255,0.15)",
                    backdropFilter: "blur(8px)",
                    color: "#ffffff",
                    fontWeight: 600,
                    fontSize: "14px",
                    padding: "12px 24px",
                    borderRadius: "999px",
                    border: "1px solid rgba(255,255,255,0.3)",
                    textDecoration: "none",
                  }}
                >
                  Explorar destino
                </a>
              </motion.div>

            </div>
          </div>

          {/* Scroll indicator */}
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 1.3, duration: 0.8 }}
            style={{
              position: "absolute",
              bottom: "40px",
              right: "40px",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: "8px",
            }}
          >
            <span style={{
              color: "rgba(255,255,255,0.35)",
              fontSize: "9px",
              fontWeight: 700,
              letterSpacing: "0.25em",
              textTransform: "uppercase",
              writingMode: "vertical-rl",
            }}>
              scroll
            </span>
            <motion.div
              animate={{ y: [0, 8, 0] }}
              transition={{ repeat: Infinity, duration: 1.6, ease: "easeInOut" }}
              style={{
                width: "20px",
                height: "32px",
                borderRadius: "999px",
                border: "2px solid rgba(255,255,255,0.3)",
                display: "flex",
                alignItems: "flex-start",
                justifyContent: "center",
                paddingTop: "4px",
              }}
            >
              <div style={{
                width: "4px",
                height: "8px",
                borderRadius: "999px",
                backgroundColor: "rgba(255,255,255,0.5)",
              }} />
            </motion.div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
